export const getFirstErrorFieldName = (errors: Record<string, unknown>): string | null => {
    const keys = Object.keys(errors);
    if (keys.length === 0) return null;

    const key = keys[0]!;
    const value = errors[key];

    if (!value || typeof value !== 'object') {
        return key;
    }

    const obj = value as Record<string, unknown>;

    // RHF/Yup leaf errors always contain { message: string }
    const isLeafError = typeof obj.message === 'string';

    if (isLeafError) {
        return key;
    }

    // Otherwise treat it as nested object (arrays, objects)
    const nested = getFirstErrorFieldName(obj);
    return nested ? `${key}.${nested}` : key;
};
